import { IApiBaseProps, IItemResponseWithSuccess } from '@common/api.models';
import { createGetOptionsCustomPropsWithSearchFn, createGetOptionsWithSearchFn } from '@common/selectOptions.services';
import { envConfigs } from '@config/envConfigs';
import { blobToBase64Async, IItemResponseBase } from '@gcl/react-core';
import { IProjectUserProfileOption } from '@userProfile/projectUserProfile.models';
import { IUserProfileOption } from '@userProfile/userProfile.models';
import { apiServerGet } from '@common/axios.services';
import { IMyDataRequest, IMyDataResponse, IUserInfo } from './user.models';

export const apiRoutes = {
  rseOptions: '/Users/Rse/Options/Search',
  searchUserInfo: '/Users/Search',
  getMyData: '/Users/Me',
  userDistributionOption: '/Users/Distributions/Options/Search',
  userAvatar: (uid: string) => `/Users/${uid}/Avatar`,
};

export interface ISearchUserInfoAsyncProps {
  keyword: string;
  projectId?: number;
}

export const searchUserInfoAsync = async (props?: ISearchUserInfoAsyncProps): Promise<IItemResponseBase<IUserInfo>> => {
  const result = await apiServerGet<IItemResponseBase<IUserInfo>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.searchUserInfo}`,
    {
      params: {
        ...props,
      },
    },
  );
  return result.data;
};

export const getMyDataAsync = async (props: IMyDataRequest): Promise<IItemResponseWithSuccess<IMyDataResponse>> => {
  const result = await apiServerGet<IItemResponseWithSuccess<IMyDataResponse>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getMyData}`,
    {
      params: { ...props },
    },
  );
  return result.data;
};

export const getRseOptionsWithSearchAsync = createGetOptionsWithSearchFn<IUserProfileOption>(apiRoutes.rseOptions);

export interface IGetUserDistributionOptionsWithSearchProps extends IApiBaseProps {
  masterScheduleId: number;
  projectCompanyId: number;
  keyword: string;
}
export const getUserDistributionOptionsWithSearchAsync = createGetOptionsCustomPropsWithSearchFn<
  IProjectUserProfileOption,
  IGetUserDistributionOptionsWithSearchProps
>(apiRoutes.userDistributionOption);

export const getUserAvatarAsync = async (uid: string): Promise<string> => {
  const result = await apiServerGet<Blob>(`${envConfigs.apiBaseUrl}${apiRoutes.userAvatar(uid)}`, {
    responseType: 'blob',
  });
  const blob: Blob = result.data;
  const dataUrl: string = (await blobToBase64Async(blob)) as string;
  return dataUrl;
};
